import styled from 'styled-components';

const MyDiv = styled.div`
  .page_wrapper {
     padding-top: 8px;
     
  }

  .page_heading {
    margin-bottom: 16px;
  }

  .flex_header {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .filter_section {
    display: flex;
    gap: 10px;
  }
  .icon_btn {
   min-width: 40px;
    cursor: pointer;  
  }
  /* Calendar */
  .react-calendar {
    font-family: 'Poppins', sans-serif;
    width: 220px;
    max-width: 100%;
    font-size: 12px;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  }

  .react-calendar__tile {
    padding: 6px 0;
  }

  .react-calendar__navigation button {
    min-width: 28px;
    font-size: 12px;
  }

  .react-calendar__month-view__days__day--weekend {
    color: #ff6b6b;
  }

  /* Table */
  .table_header {
    background-color: #f9fafb !important;
  }

  .row_striped {
    background-color: #f1f5f9;
  }

 .empId {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    white-space: nowrap; 
    cursor: pointer;
  }

  .status_badge {
    padding: 3px 6px;
    font-size: 12px;
    border-radius: 4px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    display: inline-block;
  }

  .status_badge.green {
    background-color: #dcfce7;
    color: #15803d;
  }

  .status_badge.red {
    background-color: #fee2e2;
    color: #b91c1c;
  }

  .status_badge.orange {
    background-color: #fff7ed;
    color: #c2410c;
  }

  .status_badge.blue {
    background-color: #e0f2fe;
    color: #0369a1;
  }

  .status_badge.purple {
    background-color: #ede9fe;
    color: #6d28d9;
  }
  .status_badge.pink {
    background-color: #ede9fe;
    color: #b4288aff;
  }
  .status_badge.yellow {
    background-color: #e7e6e1ff;
    color: #f4ca0eff;
  }

    .status_badge.cyan {
  background-color: #e0f7faff;
  color: #00bcd4;              
}

.status_badge.teal {
  background-color: #ccfbf1;
  color: #0f766e;
}

.status_badge.amber {
  background-color: #fef3c7;
  color: #b45309;
}

  /* Typography Utility */
  .font-poppins {
    font-family: 'Poppins', sans-serif;
  }

  .text_lg {
    font-size: 18px;
  }

  .text_md {
    font-size: 14px;
  }

  .text_sm {
    font-size: 12px;
  }

  .text_medium {
    font-weight: 500;
  }

  .text_regular {
    font-weight: 400;
  }
`;

export default MyDiv;
